export enum PaymentType {
  PPT = "ppt",
  FLAT = "flat",
  PROVISION = "provision"
}
